// extracted by mini-css-extract-plugin
module.exports = {"toolTip":"UiSelectTooltip_toolTip_2nQ6G"};